import { useId } from 'react';

/**
 * The floor of a homepage stage (`.rt-stage`): a blueprint grid that scrolls
 * with the section, fading out toward the edges. An SVG pattern, not a
 * gradient — a gradient painting a line token is the banned "ring"
 * construction (seamPrimitiveUsage.test.ts), and a pattern draws a crisp
 * hairline at any zoom.
 */
export default function StageBackdrop() {
  // Two stages share the page; each pattern needs its own id, and one that a
  // CSS url() reference accepts verbatim.
  const id = `stage-grid-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  return (
    <div aria-hidden className="stage-grid pointer-events-none absolute inset-0 overflow-hidden">
      <svg className="absolute inset-0 h-full w-full">
        <defs>
          <pattern id={id} width="56" height="56" patternUnits="userSpaceOnUse">
            <path d="M 56 0 L 0 0 0 56" fill="none" stroke="var(--rt-hairline)" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${id})`} />
      </svg>
    </div>
  );
}
